import { Building2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { endSession } from '../../services/auth-token';
import logo from '../../asset/images/logo.png';

/**
 * Terminal state for the post-login org bootstrap: the user is authenticated
 * but their organisation list came back empty.
 *
 * DV-2897/DV-3175 — an empty list for a fully-registered user is not a
 * transient condition to retry, it is a dead end. Their Keycloak group
 * membership is missing and only an operator can put it back, so both
 * bootstrap screens (`Loader` and `CallBack`) render this instead of asking
 * again. It is a rendered screen rather than a toast on purpose: the toast
 * auto-dismisses after six seconds and left the user staring at a spinner
 * with no explanation.
 *
 * Sign Out is the only action offered. There is nowhere in the app to send
 * them — every route needs an entity scope they do not have — and routing to
 * '/' would re-enter this same bootstrap. Signing out is user-initiated so
 * they get to read the message first, and lets them retry with another
 * account.
 *
 * @category Pages
 */
function NoOrganizations() {
  return (
    <section className="flex min-h-screen flex-col items-center justify-center bg-muted p-6">
      <div className="w-full max-w-[480px] rounded-lg border border-border bg-background px-10 py-12 shadow-modal">
        <div className="mb-2 flex justify-center">
          <img src={logo} alt="PlanOmatic logo" width="184" height="43" />
        </div>
        <EmptyState
          icon={Building2}
          titleAs="h1"
          title="No Organizations Available"
          description="Your account isn't associated with any organizations, so there is nothing to load. Please contact support to have your access restored."
          action={<Button onClick={endSession}>Sign Out</Button>}
        />
      </div>
    </section>
  );
}

export default NoOrganizations;
